import React, { Component } from 'react';
import Picture from '../image/CloudFrontPicture';
import Carousel from '../stepper/Carousel';

import FigCaption from '../common/FigCaption';

class SewpatPictures extends Component {

    buildStepsToRender = () => (
        this.props.sewpat.images.map((step, index) => (
            <figure className='stolo-carousel-container' key={index}>
                <Picture
                    src={step.src}
                    webp={step.webp}
                    alt={step.alt}
                    schnoffle
                    path={`schnittmuster/${this.props.sewpat.id}`}
                />
                <FigCaption>
                    {step.caption}
                </FigCaption>
            </figure>
        ))
    );

    getMaxSteps = () => (this.props.sewpat.images.length - 1);

    render() {
        return (
            <Carousel activeStep={0} maxSteps={this.getMaxSteps()}>
                {(activeStep, handleStepChange) => (
                    <React.Fragment>
                        <Carousel.Steps
                            activeStep={activeStep}
                            handleStepChange={handleStepChange}
                        >
                            {this.buildStepsToRender()}
                        </Carousel.Steps>
                    </React.Fragment>
                )}
            </Carousel>

        );
    }
}


export default SewpatPictures;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatPictures.js